import React, { useEffect } from 'react';
import styled from 'styled-components';

import BasketToggle from './Buttons/BasketToggle';
import ChatToggle from './Buttons/ChatToggle';
import ReactionToggle from './Buttons/ReactionToggle';
import { heartAnimation } from '../../util/util';

const Container = styled.div`
	height: 100%;
	width: 15%;
	opacity: 100%;
	display: flex;
	flex-direction: column-reverse;
	pointer-events: none;
	padding-bottom: 25px;
	@media screen and (max-width: 992px) and (orientation: landscape) and (hover: none) and (pointer: coarse) {
		width: auto;
	}
`;

const ChatButtonsWrapper = ({ settings, basketItemCount, handleReactionPost, reactionId, isShowViewerEngagementModule }) => {
	useEffect(() => {
		if (!reactionId) {
			return;
		}

		heartAnimation('bottomControlbarHearts--mobile');
	}, [reactionId]);

	return (
		<>
			{settings.engagementFeatures.enabled && (
				<Container style={{ userSelect: 'none' }}>
					{settings.engagementFeatures.showChat && isShowViewerEngagementModule && <ChatToggle />}
					{settings.engagementFeatures.showShoppingCart && (
						<BasketToggle color={settings?.playerStyling?.primaryColor ?? '#126cfc'} basketItemCount={basketItemCount} />
					)}
					{settings.engagementFeatures.showLiveLikes && (
						<ReactionToggle
							heartAnimation={() => {
								heartAnimation();
								handleReactionPost?.();
							}}
							container={
								<div
									className="bottomControlbarHearts--mobile"
									style={{ position: 'absolute', left: '30%', userSelect: 'none' }}
									tabIndex={-1}
								/>
							}
						/>
					)}
				</Container>
			)}
		</>
	);
};

export { ChatButtonsWrapper };
